// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import styled from 'styled-components';

const StyledWrapper = styled.span`
  margin-left: 15px;
  cursor: pointer;
  color: #adb5bd;

  i {
    font-size: 18px;
  }
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const ActivityViewActionIcon = ({ action, onClick, disabled = false }) => {
  return (
    <StyledWrapper
      className={`${disabled ? 'disabled' : ''}`}
      onClick={onClick}
    >
      <i className={`fas fa-${action}`} />
    </StyledWrapper>
  );
};

export default ActivityViewActionIcon;
